import { capitalizeFirstLetter } from 'themes/helpers/capitalizeFirstLetter';

import * as S from './Headline.styles';
import { TextProps } from './Headline.styles';

export type HeadlineProps = {
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'label' | 'span';
  children: React.ReactNode;
  className?: string;
  htmlFor?: string;
} & TextProps;

const defaultProps: Partial<HeadlineProps> = {
  tag: 'p',
  className: '',
  scale: ['base', 's'],
  fontFamily: 'LFT Zeno Condensed',
  htmlFor: undefined,
};

export function Headline(props: HeadlineProps): React.ReactElement {
  const {
    tag,
    children,
    scale,
    className,
    color = 'black',
    fontWeight,
    textTransform,
    textAlign,
    fontFamily,
    isWrapped,
    htmlFor,
  } = {
    ...defaultProps,
    ...props,
  };

  return (
    <S.Text
      textAlign={textAlign}
      className={className}
      fontWeight={fontWeight}
      fontFamily={fontFamily}
      color={color}
      scale={scale}
      as={tag}
      textTransform={textTransform}
      isWrapped={isWrapped}
      htmlFor={htmlFor}
    >
      {textTransform === 'isFirstLetterUppercase' && children
        ? capitalizeFirstLetter(children.toString())
        : children}
    </S.Text>
  );
}
